import {
	ChangeDetectorRef,
	Component,
	ComponentFactoryResolver,
	ElementRef,
	Host,
	HostBinding,
	Input, OnDestroy,
	Optional,
	Renderer2,
	ViewContainerRef,
} from '@angular/core';
import { BADGE, IBadge, Status } from '@app/components/elements/badge.type';
import { ThemeType } from '@ant-design/icons-angular';
import { NzTooltipDirective } from 'ng-zorro-antd/tooltip';
import { NzNoAnimationDirective } from 'ng-zorro-antd/core/no-animation';
import { BehaviorSubject, of, Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { switchMap } from 'rxjs/operators';

@Component({
	// eslint-disable-next-line @angular-eslint/component-selector
	selector: 'button[workflowStep]',
	templateUrl: './step-button.component.html',
	styleUrls: ['./step-button.component.scss'],
	providers: [
		{
			provide: BADGE,
			useExisting: StepButtonComponent,
		},
	],
})
export class StepButtonComponent extends NzTooltipDirective implements IBadge, OnDestroy {
	private readonly subscription = new Subscription();
	private readonly label$ = new BehaviorSubject<string | undefined>(undefined);
	
	@Input()
	public set label(text: string | null) {
		this.label$.next(text);
	}
	
	// eslint-disable-next-line @angular-eslint/no-input-rename
	@Input('workflowStep')
	public name?: string;
	@Input()
	public icon?: string;
	@Input()
	public iconTheme?: ThemeType;
	
	@HostBinding('style.color')
	public color = 'inherit';
	@Input()
	@HostBinding()
	private disabled: boolean;
	
	constructor(
		translateService: TranslateService,
		private readonly cdr: ChangeDetectorRef,
		elementRef: ElementRef,
		hostView: ViewContainerRef,
		resolver: ComponentFactoryResolver,
		renderer: Renderer2,
		@Host() @Optional() noAnimation?: NzNoAnimationDirective,
	) {
		super(elementRef, hostView, resolver, renderer, noAnimation);
		
		this.subscription.add(
			this.label$.pipe(
				switchMap(label => label ? translateService.get(label) : of(null)),
			).subscribe(title => this.title = title),
		);
	}
	
	public setStatus({ label, iconTheme, iconName, color, disabled }: Status): void {
		this.label = label;
		this.icon = iconName;
		this.iconTheme = iconTheme;
		this.color = color;
		this.disabled = disabled;
		this.cdr.markForCheck();
	}
	
	public ngOnDestroy(): void {
		super.ngOnDestroy();
		this.subscription.unsubscribe();
	}
}
